export default {
    GET_DETAILS_PER_WORKER_LIST(state, payload) {
        state.list = payload;
    },
};
